/* AskTimmy zet bij openen van de chat body op position:fixed (eigen app-CSS). Dit onthoudt de scrollpositie, houdt de pagina op die plek tijdens de chat en zet hem na sluiten terug. */
(function () {
  var saved = null;
  var last = window.scrollY || 0;
  window.addEventListener('scroll', function () {
    if (saved === null) last = window.scrollY;
  }, { passive: true });
  function sync() {
    var open = !!document.querySelector('.chat-window-container.askTimmy-show');
    if (open && saved === null) {
      saved = last;
      document.body.style.top = (-saved) + 'px';
      document.body.style.width = '100%';
    } else if (!open && saved !== null) {
      var y = saved;
      saved = null;
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, y);
    }
  }
  new MutationObserver(sync).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
})();
